import React, { useCallback, useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMatrix, saveMatrix } from 'actions/matrices';
import './BuildMatrixModal.scss';
import BuildMatrixIntro from './BuildMatrixIntro';
import StickySideModal from '../StickySideModal';
import { startEdit, finishEdit } from 'actions/matrixSettings';
import BuildMatrixAddNodes from './BuildMatrixAddNodes';

const buildSteps = ['intro', 'createMatrix'];

const BuildMatrixModal = ({ matrix }) => {
  const dispatch = useDispatch();

  const [buildStep, setBuildStep] = useState({
    step: 0,
  });

  const history = useHistory();

  const editMatrix = useSelector(state => state.matrixSettings.matrix);

  const finishStep = useCallback(() => {
    // We have the matrix, but fetch anyway since it's all
    // saved and hasn't hit the loading list
    dispatch(fetchMatrix(matrix.id));
    history.push(`/matrices/${matrix.id}/edit`);
  }, [dispatch, history, matrix]);

  const returnComponentForStep = step => {
    switch (step) {
      case 'intro': {
        return (
          <BuildMatrixIntro finishStep={() => setBuildStep({ step: 1 })} />
        );
      }
      case 'createMatrix': {
        return (
          <BuildMatrixAddNodes
            matrix={editMatrix}
            toNext={() => {
              dispatch(finishEdit(editMatrix));
              dispatch(saveMatrix(editMatrix.id));
              // TODO race condition, not great solution
              // Maybe wait for editMatrix to be gone?
              setTimeout(finishStep, 150);
            }}
            toPrev={() => setBuildStep({ step: 0 })}
          />
        );
      }
      default: {
        return null;
      }
    }
  };

  // onMount
  useEffect(() => {
    dispatch(startEdit(matrix));
  }, [dispatch, matrix]);

  return (
    <StickySideModal className={''} onExit={() => false}>
      <div className="BuildMatrixModal">
        {returnComponentForStep(buildSteps[buildStep.step])}
      </div>
    </StickySideModal>
  );
};

export default BuildMatrixModal;
